import React, { useState } from "react";

const UtilizedBudgetBody = ({
  subActivity,
  fy_list,
  storedGlobalDateId,
  addElipsis,
  formatNumber,
  activityId
}) => {


  const [subheadAccording, setSubheadAccording] = useState({});
  let finalTotalVendor = 0;
  let finalTotalDbt = 0;
  let finalTotalBudgetAllocation = 0;

  subActivity?.forEach((ele) => {
    finalTotalVendor += ele?.activityId === activityId &&
      Number(ele?.current_fy?.vendor) + Number(ele?.from_prev_fy?.vendor);
    finalTotalDbt += ele?.activityId === activityId &&
      Number(ele?.current_fy?.dbt) + Number(ele?.from_prev_fy?.dbt);
    finalTotalBudgetAllocation += ele?.activityId === activityId &&
      Number(ele?.current_fy?.budget_allocation) +
      Number(ele?.from_prev_fy?.budget_allocation);
  });

  const grandTotal =
    finalTotalVendor + finalTotalDbt + finalTotalBudgetAllocation;

  
  const toggleSubhead = (activityId) => {
      setSubheadAccording((prev) => ({
          ...prev,
          [activityId]: !prev[activityId], // Toggle for specific activityId
      }));
  };

  return (
    <div>
      {subActivity?.map((vals, ind) => vals?.activityId === activityId && (
        <div
          className="row fs-14px p-1 fw-500 overflow-hidden"
          style={{
            background: ind % 2 == 0 ? "#F8F8F8" : "#FFFFFF",
            height: !subheadAccording[vals?.subactivityId] ? "35px" : "fit-content",
          }}
        >
          <div className="col-2 d-flex align-items-center">
            {!subheadAccording[vals?.subactivityId] ? (
              <i
                className="icon-keyboard_arrow_right cursor-pointer"
                onClick={() => toggleSubhead(vals?.subactivityId)}
              ></i>
            ) : (
              <i
                className="icon-keyboard_arrow_down cursor-pointer"
                onClick={() => toggleSubhead(vals?.subactivityId)}
              ></i>
            )}
            <span>{ addElipsis(vals?.subactivityName, 13)}</span>
          </div>
          <div className="col-2">
            {
              (Number(vals?.from_prev_fy?.vendor) +
              Number(vals?.current_fy?.vendor)) == 0 ? "-" 
              : formatNumber(
                Number(vals?.from_prev_fy?.vendor) +
                  Number(vals?.current_fy?.vendor) , "indian"
              )

              }
          </div>
          <div className="col-2">
            {(Number(vals?.from_prev_fy?.dbt) + Number(vals?.current_fy?.dbt)) == 0 ? "-" : 
              formatNumber(
                Number(vals?.from_prev_fy?.dbt) +
                  Number(vals?.current_fy?.dbt), "indian"
              )
            }
          </div>
          <div className="col-2">-</div>
          <div className="col-2">
            {
              (Number(vals?.from_prev_fy?.budget_allocation) +
              Number(vals?.current_fy?.budget_allocation)) == 0 ? "-" :
              formatNumber(
                Number(vals?.from_prev_fy?.budget_allocation) +
                  Number(vals?.current_fy?.budget_allocation), "indian"
              )
              }
          </div>
          <div className="col-2 text-success-100">
            { (Number(vals?.from_prev_fy?.vendor) +
              Number(vals?.from_prev_fy?.dbt) +
              Number(vals?.from_prev_fy?.budget_allocation) +
              Number(vals?.current_fy?.vendor) +
              Number(vals?.current_fy?.dbt) +
              Number(vals?.current_fy?.budget_allocation)) == 0 ? "-" :
              formatNumber(
                Number(vals?.from_prev_fy?.vendor) +
                  Number(vals?.from_prev_fy?.dbt) +
                  Number(vals?.from_prev_fy?.budget_allocation) +
                  Number(vals?.current_fy?.vendor) +
                  Number(vals?.current_fy?.dbt) +
                  Number(vals?.current_fy?.budget_allocation), "indian"
              )
              
              }
          </div>
          <div className="mt-1">
            <div className="row fs-14px p-1 fw-500">
              <div className="col-2 text-prime-100 fs-12px">
                FY {fy_list[storedGlobalDateId]?.year}
              </div>
              <div className="col-2">{vals?.current_fy?.vendor == 0 ? "-" : formatNumber(vals?.current_fy?.vendor, "indian")}</div>
              <div className="col-2">{vals?.current_fy?.dbt == 0 ? "-" : formatNumber(vals?.current_fy?.dbt , "indian") }</div>
              <div className="col-2">-</div>
              <div className="col-2">{vals?.current_fy?.budget_allocation == 0 ? "-" : formatNumber(vals?.current_fy?.budget_allocation, "indian")}</div>
              <div className="col-2 text-success-100">
                {
                  (Number(vals?.current_fy?.vendor) +
                  Number(vals?.current_fy?.dbt) +
                  Number(vals?.current_fy?.budget_allocation)) == 0 ? "-" :
                  formatNumber(
                    Number(vals?.current_fy?.vendor) +
                      Number(vals?.current_fy?.dbt) +
                      Number(vals?.current_fy?.budget_allocation), "indian"
                  )
                  }
              </div>
            </div>

            <div className="row fs-14px p-1 fw-500">
              <div className="col-2 text-prime-100 fs-12px">
                Previous Year Balance
              </div>
              <div className="col-2">{vals?.from_prev_fy?.vendor == 0 ? "-" : formatNumber(vals?.from_prev_fy?.vendor, "indian")}</div>
              <div className="col-2">{vals?.from_prev_fy?.dbt == 0 ? "-" : formatNumber(vals?.from_prev_fy?.dbt, "indian")}</div>
              <div className="col-2">-</div>
              <div className="col-2">
                {vals?.from_prev_fy?.budget_allocation == 0 ? "-" : formatNumber(vals?.from_prev_fy?.budget_allocation, "indian")}
              </div>
              <div className="col-2 text-success-100">
                {
                  (Number(vals?.from_prev_fy?.vendor) +
                  Number(vals?.from_prev_fy?.dbt) +
                  Number(vals?.from_prev_fy?.budget_allocation)) == 0 ? "-" :
                  formatNumber(
                    Number(vals?.from_prev_fy?.vendor) +
                      Number(vals?.from_prev_fy?.dbt) +
                      Number(vals?.from_prev_fy?.budget_allocation), "indian"
                  )
                  }
              </div>
            </div>
          </div>
        </div>
      ))}

      <div className="row fs-14px p-1 fw-500 bg-info-20">
        <div className="col-2 text-prime-100 fs-12px">Total</div>
        <div className="col-2">{finalTotalVendor == 0 ? "-" : formatNumber( finalTotalVendor, "indian")}</div>
        <div className="col-2">{finalTotalDbt == 0 ? "-" : formatNumber( finalTotalDbt, "indian")}</div>
        <div className="col-2">-</div>
        <div className="col-2">{finalTotalBudgetAllocation == 0 ? "-" : formatNumber( finalTotalBudgetAllocation, "indian")}</div>
        <div className="col-2 text-success-100">{grandTotal == 0 ? "-" : formatNumber( grandTotal, "indian")}</div>
      </div>
    </div>
  );
};

export default UtilizedBudgetBody;
